// extracted by mini-css-extract-plugin
module.exports = {"videoItem":"VideoItem_videoItem__3Wup_","video":"VideoItem_video__3LFQB","title":"VideoItem_title__2uU7c","date":"VideoItem_date__1ZUfh"};